"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(require("./local-workspace-repository"));
__export(require("./local-workspace-window-repository"));
__export(require("./workspace"));
__export(require("./workspace-window"));



//////////////////
// WEBPACK FOOTER
// /app/~/redi-workspaces-web-lib/dist/business/index.js
// module id = 134
// module chunks = 0